export default "__VITE_ASSET__B3ny1M0Y__"